type DateRange = {
  start_date: string;
  end_date: string;
};

const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getQuarter = (month: number) => Math.floor(month / 3);

export const getDateRange = (type: string): DateRange => {
  const today = new Date();
  const todayMinusTwo = new Date();
  todayMinusTwo.setDate(today.getDate() - 2);

  switch (type) {
    case "Yesterday": {
      const y = new Date();
      y.setDate(today.getDate() - 1);
      return {
        start_date: formatDate(y),
        end_date: formatDate(y),
      };
    }

    case "Last 7 days": {
      const end = new Date(today);
      end.setDate(today.getDate() - 1);
      const start = new Date(today);
      start.setDate(today.getDate() - 8);
      return {
        start_date: formatDate(start),
        end_date: formatDate(end),
      };
    }

    case "MTD": {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      return {
        start_date: formatDate(start),
        end_date: formatDate(today),
      };
    }

    case "Last month": {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end = new Date(today.getFullYear(), today.getMonth(), 0);
      return {
        start_date: formatDate(start),
        end_date: formatDate(end),
      };
    }

    case "YTD": {
      const start = new Date(today.getFullYear(), 0, 1);
      const end = new Date();
      end.setDate(today.getDate() - 1);
      return {
        start_date: formatDate(start),
        end_date: formatDate(end),
      };
    }

    case "QTD": {
      const currentYear = today.getFullYear();
      const currentQuarter = getQuarter(today.getMonth());
      const startMonth = currentQuarter * 3;
      const start = new Date(currentYear, startMonth, 1);
      return {
        start_date: formatDate(start),
        end_date: formatDate(todayMinusTwo),
      };
    }

    default:
      throw new Error("Invalid date type");
  }
};
